/** Landing dashboard inside the gated shell. */
import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";

export function DashboardPage(): ReactNode {
  const { identity } = useAuth();
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-slate-800">Dashboard</h1>
      <p className="text-sm text-slate-600">
        Signed in as <strong>{identity?.email || identity?.userId}</strong> ·{" "}
        <span className="text-slate-500">{identity?.systemRoles.join(", ")}</span>
      </p>
      <div className="rounded-lg border border-slate-200 bg-white p-5 text-sm text-slate-600">
        <p className="mb-2 font-medium text-slate-700">OXBO Admin console</p>
        <p>
          Auth administration (users, organizations, invitations, access requests, system-role
          assignment) ships in ADMIN-PR1. Masters catalog administration ships in ADMIN-PR2.
        </p>
      </div>
    </div>
  );
}
